import { StepImpl } from './step-impl';
import { Control } from '../controls/control';
import { StepDelegate } from '../intefaces/step-delegate';
import { Observable, of } from 'rxjs';

export class FormStep extends StepImpl {
  private stepDelegate?: StepDelegate;

  constructor(text: string, name: string, public forms: Control<any>[][]) {
    super(text, name);
  }

  setDelegate(form: StepDelegate): void {
    this.stepDelegate = form;
    this.stepDelegate.ready.subscribe((ready) => (this.ready = ready));
  }

  submit(): Observable<boolean> {
    return this.stepDelegate?.onSubmit() || of(true);
  }
}
